import startContent from "./start-content.json";
import FloatingBackButton from "../components/FloatingBackButton";
import desktopContent from "./desktop-content.json";
import {Spacer} from "../components/Spacer";
import ParallaxPage from "../components/ParallaxPage";
import React from "react";
import {ParagraphsComponent} from "../components/ParagraphsComponent";

export const Desktop = () => {
    return (
        <div>
            <FloatingBackButton/>
            <ParallaxPage
                imageUrl={startContent.desktop.imageUrl}
                content={
                    <div>
                        <h1>{desktopContent.title}</h1>
                        <h2>{desktopContent.subtitle}</h2>
                        <Spacer height={100}/>
                        <ParagraphsComponent paragraphs={desktopContent.paragraphs} />
                    </div>
                }
            />
        </div>
    );
};